"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var purry_1 = require("./purry");

var _filterObj = function _filterObj(list, fn) {
  var result = {};
  Object.keys(list).forEach(function (key) {
    if (fn(list[key], key)) {
      result[key] = list[key];
    }
  });
  return result;
};

function filterObj() {
  return purry_1.purry(_filterObj).apply(void 0, arguments);
}

exports.filterObj = filterObj;